import React, { useState } from "react";
import {
  Button,
  Popover,
  Typography,
  Card,
  Box,
  Divider,
  Link,
  makeStyles,
  Grid, // Usaremos Grid para reemplazar Box y Stack
} from "@material-ui/core";

// 1. Definición de estilos con makeStyles
const useStyles = makeStyles((theme) => ({
  // Estilos para el botón principal
  button: {
    // Reemplaza sx={{ justifyContent: 'flex-start' }}
    justifyContent: "flex-start",
    textTransform: "none", // Usualmente queremos esto para texto
    padding: theme.spacing(1, 2), // Ejemplo de padding
  },
  // Estilos para el texto dentro del botón
  buttonText: {
    // Reemplaza los estilos sx de Typography para truncar texto
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    maxWidth: "100%",
  },
  // Estilos para el Popover
  card: {
    // Reemplaza sx={sx ? sx : { maxWidth: 700 }}
    maxWidth: 700,
    // Puedes extender más estilos de Card aquí si es necesario
  },
  cardContent: {
    // Reemplaza el Box con padding sx={{ p: 3 }}
    padding: theme.spacing(3),
  },
  // Estilos para la fila del título (reemplaza Stack con gap=1)
  titleRow: {
    display: "flex",
    alignItems: "center", // Para alignItems="center"
    marginBottom: theme.spacing(2), // Para pb={2}
    // Reemplaza gap={1} con un margen a la derecha de los elementos
    "& > *": {
      marginRight: theme.spacing(1), // Espacio entre ícono, título y link
      "&:last-child": {
        marginRight: 0,
      },
    },
  },
  // Estilos para el texto del título que trunca
  titleTypography: {
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    maxWidth: "100%",
    flexGrow: 1, // Permite que el texto ocupe el espacio disponible
  },
  divider: {
    marginBottom: theme.spacing(3), // Para sx={{ mb: 3 }}
  },
  readMoreLink: {
    // Reemplaza sx={{ textDecoration: 'none', color: 'primary.main' }}
    textDecoration: "none",
    color: theme.palette.primary.main,
    // Aseguramos que el link no se encoja
    flexShrink: 0,
  },
}));

// Componente de ejemplo (asume que los props están definidos)
export const PopoverButton = (props) => {
  const classes = useStyles();
  const {
    id,
    variant,
    colorButton,
    variantButton,
    mask,
    maskString,
    buttonText,
    title,
    icon,
    showReadMoreLink,
    href,
    content,
    // La prop 'sx' personalizada en v5 no es fácilmente replicable sin CSS global o withStyles
  } = props;

  const [anchorEl, setAnchorEl] = useState(null)

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);

  // MUI v4 usa elevation en Paper, pero Popover lo pasa automáticamente
  return (
    <>
      <Button
        aria-describedby={id}
        variant={variant}
        onClick={handleClick}
        className={classes.button} // Aplicamos el estilo de alineación
      >
        <Typography
          color={colorButton}
          variant={variantButton}
          className={classes.buttonText} // Aplicamos los estilos de truncado
        >
          {mask ? maskString(buttonText) : buttonText}
        </Typography>
      </Button>

      <Popover
        // La prop 'elevation' se maneja internamente por Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "center",
          horizontal: "left",
        }}
        // Reemplazamos PaperProps con un className para el Card
        PaperProps={{
          className: classes.card,
        }}
      >
        <Card className={classes.card}>
          {/* Usamos un div con className para reemplazar Box con padding */}
          <div className={classes.cardContent}>
            {title && (
              <>
                {/* Usamos un div con className para reemplazar Stack */}
                <div className={classes.titleRow}>
                  {icon}
                  {typeof title === "string" ? (
                    <Typography
                      variant="h5"
                      // Nota: MUI v4 usa 'textSecondary' o 'custom colors' en lugar de 'grayText'
                      color="textSecondary"
                      // No hay prop 'fontWeight' en Typography V4, se usa CSS
                      className={classes.titleTypography}
                    >
                      {title}
                    </Typography>
                  ) : (
                    title
                  )}
                  {showReadMoreLink && href && (
                    <Link
                      underline="hover"
                      variant="body2"
                      className={classes.readMoreLink} // Aplicamos el estilo de color y deco
                      id={id}
                      href={href}
                    >
                      {t("read.more")}
                    </Link>
                  )}
                </div>
                <Divider className={classes.divider} />
              </>
            )}
            {/* Contenido principal */}
            <div className={classes.contentBox}>{content}</div>
          </div>
        </Card>
      </Popover>
    </>
  );
};
